import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SearchInput } from "../common/SearchInput";
import { useDispatch, useSelector } from "react-redux";
import {
  checkIsAuth,
  checkIsName,
  checkIsRool,
  logout,
} from "../../features/redux/authSlice";
import { MenuItem } from "./MenuItem";
import { buttonsConfig } from "../../util/rool";
import { SmsPanel } from "./SmsPanel";
import { MenuProfile } from "./MenuProfile";
import { ProfileAvatar } from "./ProfileAvatar";
import { MenuToggle } from "./MenuToggle";
import { DashboardNavButton } from "./DashboardNavButton";
// import { chartLine } from "./header_svg";
// import { FaChartLine } from "react-icons/fa";
import { BsCalendar3, BsList } from "react-icons/bs";

const CALENDAR_ROLES = ["admin", "director", "manager", "print", "keeper"];

// Страница списка менеджера для каждой роли
const MANAGER_LIST_PATH = {
  manager: "/",
  keeper: "/",
};

const Header = () => {
  const isAuth = useSelector(checkIsAuth);
  const isName = useSelector(checkIsName);
  const userRole = useSelector(checkIsRool);
  const dispatch = useDispatch();
  const location = useLocation();
  const isOnCalendar = location.pathname === "/managercal";
  const [isClipboardOpen, setIsClipboardOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const clipboardRef = useRef(null);
  const profileRef = useRef(null);

console.log(userRole);


  const handleLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        clipboardRef.current &&
        !clipboardRef.current.contains(event.target)
      ) {
        setIsClipboardOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="flex py-4 justify-between fixed w-full top-0 bg-[#F2F2F2] container m-auto z-50">
      <div className="w-full mx-auto flex items-center">
        <div className="flex w-[13%] gap-10">
          <span className="flex items-center">
            {/* <img
              src={`${process.env.PUBLIC_URL}/assets/Logo EasyGazibo.png`}
              alt="logo"
            />*/}
          </span>
        </div>
        {/* 
       Semantic Versioning
          Major — Breaking changes / Significant changes (Глобальные изменения / Изменения, нарушающие обратную совместимость)
          Minor — New features / Backward-compatible functionality (Новый функционал / Функционал с сохранением обратной совместимости)
          Patch — Bug fixes / Maintenance updates (Исправления ошибок / Обновления для поддержания стабильности)
        */}
        <div
          className="flex w-[5%] h-[75px] text-[#739D00] font-light font-rubik items-end pr-2"
          title="Semantic Versioning Major.Minor.Patch
          -Major: Incompatible API changes.
          -Minor: Added functionality in a backwards compatible manner.
          -Patch: Backwards compatible bug fixes."
        >
          v 3.44.5
        </div>
        <div className="flex items-center w-[41%] h-[48px]">
          <SearchInput />
        </div>

        {(userRole === "manager"||userRole === "keeper")? (<div className="flex items-center w-[12%] justify-center pr-4">
          {CALENDAR_ROLES.includes(userRole) && (
            <Link
              to={isOnCalendar ? MANAGER_LIST_PATH[userRole] : "/managercal"}
              title={isOnCalendar ? "Manager list" : "Manager calendar"}
            >
              {isOnCalendar ? (
                <BsList  className="text-[40px] text-[#739D00] hover:text-[#739d00a8]" />
              ) : (
                <BsCalendar3 className="text-[30px] text-[#739D00] hover:text-[#739d00a8]" />
              )}
            </Link>
          )}
        </div>):(<div className="flex items-center w-[12%]"></div>)}

        <DashboardNavButton userRole={userRole} />

        {buttonsConfig[userRole] && (
          <div className="flex items-center ">
            <div className="relative" ref={clipboardRef}>
              <MenuToggle
                isOpen={isClipboardOpen}
                toggle={() => setIsClipboardOpen(!isClipboardOpen)}
              />
              {isClipboardOpen && (
                <MenuItem
                  arr={buttonsConfig[userRole]}
                  onClose={() => setIsClipboardOpen(false)}
                />
              )}
            </div>
          </div>
        )}
        <div className="flex items-center w-[19%] justify-around">
          <div className="flex items-center font-rubik font-light text-[20px] leading-tight tracking-wide-5">
            {userRole.toUpperCase()}
          </div>

          <div className="relative flex items-center " ref={profileRef}>
            <button
              className=" overflow-hidden flex items-center justify-center"
              onClick={() => setIsProfileOpen(!isProfileOpen)}
            >
              <ProfileAvatar name={(isName && isName.username) || "none"} />
            </button>
            {isProfileOpen && (
              <MenuProfile
                isUser={isName}
                userRole={userRole}
                isAuth={isAuth}
                handleLogout={handleLogout}
                onClose={() => setIsProfileOpen(false)}
              />
            )}
          </div>
         
          {(userRole === "admin" || userRole === "director"||userRole === "desinger"||userRole === "keeper"||userRole === "manager") && (
            <SmsPanel isUser={isName} />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
